<div class="main-content" [ngStyle]="{ direction: pageDirection }">
  <div class="m-box">
    <h2>{{ 'appointments.gui.labels.financial_report.Financial Report' | translate }}</h2>

    <div class="flex flex-wrap gap-4" style="align-items: flex-end;">
      <div class="nowrap">
        <strong class="m-r-0-5">{{ 'appointments.gui.labels.From' | translate }}:</strong>
        <input [matDatepicker]="fromPicker" [(ngModel)]="filterFromDate" class="t-field t-field--date menstural-field date-input" (click)="fromPicker.open()" />
        <mat-datepicker #fromPicker></mat-datepicker>
      </div>
      <div class="nowrap">
        <strong class="m-r-0-5">{{ 'appointments.gui.labels.Until' | translate }}:</strong>
        <input [matDatepicker]="toPicker" [(ngModel)]="filterToDate" class="t-field t-field--date menstural-field date-input" (click)="toPicker.open()" />
        <mat-datepicker #toPicker></mat-datepicker>
      </div>
      <div>
        <strong class="m-r-0-5">{{ 'appointments.gui.labels.financial_report.Performer' | translate }}:</strong>
        <select class="t-field" [(ngModel)]="doctorFilter">
          <option value="ALL">{{ 'appointments.gui.labels.appointment_stats.All' | translate }}</option>
          <option *ngFor="let doctor of loginService.clinicUsers" [ngValue]="doctor.UID">{{ doctor.Name }}</option>
        </select>
      </div>
      <div>
        <strong class="m-r-0-5">{{ 'appointments.gui.labels.financial_report.Exam Type' | translate }}:</strong>
        <select class="t-field" [(ngModel)]="examTypeFilter">
          <option value="ALL">{{ 'appointments.gui.labels.appointment_stats.All' | translate }}</option>
          <option *ngFor="let type of examTypeOptions" [value]="type.value">{{ type.label }}</option>
        </select>
      </div>
      <div>
        <strong class="m-r-0-5">{{ 'appointments.gui.labels.Payer' | translate }}:</strong>
        <select class="t-field" [(ngModel)]="payerFilter">
          <option value="ALL">{{ 'appointments.gui.labels.appointment_stats.All' | translate }}</option>
          <option *ngFor="let payer of financialService.payers" [value]="payer">{{ financialService.payerMapping[payer] }}</option>
        </select>
      </div>
      <div>
        <strong class="m-r-0-5">{{ 'appointments.gui.labels.financial_report.Patient' | translate }}:</strong>
        <input class="t-field" type="text" [(ngModel)]="patientFilter" (keyup.enter)="search()" />
      </div>
      <div>
        <strong class="m-r-0-5">{{ 'appointments.gui.labels.financial_report.Payer Status' | translate }}:</strong>
        <select class="t-field" [(ngModel)]="payerStatusFilter">
          <option value="ALL">{{ 'appointments.gui.labels.appointment_stats.All' | translate }}</option>
          <option *ngFor="let status of financialService.statuses" [value]="status">{{ 'appointments.gui.labels.financial_report.status.' + status | translate }}</option>
        </select>
      </div>
      <div>
        <strong class="m-r-0-5">{{ 'appointments.gui.labels.financial_report.Performer Status' | translate }}:</strong>
        <select class="t-field" [(ngModel)]="performerStatusFilter">
          <option value="ALL">{{ 'appointments.gui.labels.appointment_stats.All' | translate }}</option>
          <option *ngFor="let status of financialService.statuses" [value]="status">{{ 'appointments.gui.labels.financial_report.status.' + status | translate }}</option>
        </select>
      </div>
      <div>
        <strong class="m-r-0-5">{{ 'appointments.gui.labels.financial_report.Group By' | translate }}:</strong>
        <select class="t-field" [(ngModel)]="groupBy">
          <option value="none">{{ 'appointments.gui.labels.financial_report.No Grouping' | translate }}</option>
          <option value="doctor">{{ 'appointments.gui.labels.financial_report.Performer' | translate }}</option>
          <option value="payer">{{ 'appointments.gui.labels.Payer' | translate }}</option>
          <option value="examType">{{ 'appointments.gui.labels.financial_report.Exam Type' | translate }}</option>
        </select>
      </div>
      <button class="blue-btn" [disabled]="!canSearch" (click)="search()">{{ 'appointments.gui.labels.appointment_stats.Search' | translate }}</button>
      <button class="blue-btn" [disabled]="!canSearch || exporting" (click)="exportExcel()">{{ 'appointments.gui.labels.financial_report.Export To Excel' | translate }}</button>
    </div>

    <p *ngIf="error" class="error-text">{{ 'appointments.gui.labels.Financial Save Error' | translate }}</p>

    <ng-container *ngIf="loading">
      <div style="width: 100%; display: flex; justify-content: center; padding: 2em 0;">
        <img style="width: 30%; margin: 0 2em;" src="../../assets/images/Wedges.svg" />
      </div>
    </ng-container>

    <ng-container *ngIf="totals && !loading">
      <hr />
      <h3>{{ 'appointments.gui.labels.financial_report.Summary' | translate }}</h3>
      <table>
        <tr>
          <th>{{ 'appointments.gui.labels.financial_report.Exam Count' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Total Reimbursement' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Received From Payer' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Awaiting Payment' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Not Yet Sent' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Total Remuneration' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Paid To Performers' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Left To Pay Performers' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Missing Price' | translate }}</th>
        </tr>
        <tr>
          <td>{{ totals.examCount }}</td>
          <td>{{ totals.totalReimbursement | number:'1.0-2' }}</td>
          <td>{{ totals.receivedFromPayer | number:'1.0-2' }}</td>
          <td>{{ totals.awaitingPayment | number:'1.0-2' }}</td>
          <td>{{ totals.notYetSent | number:'1.0-2' }}</td>
          <td>{{ totals.totalRemuneration | number:'1.0-2' }}</td>
          <td>{{ totals.paidToPerformers | number:'1.0-2' }}</td>
          <td>{{ totals.leftToPayPerformers | number:'1.0-2' }}</td>
          <td [style.color]="totals.missingPriceCount ? 'red' : null">{{ totals.missingPriceCount }}</td>
        </tr>
      </table>

      <ng-container *ngIf="groups.length">
        <h3>{{ 'appointments.gui.labels.financial_report.Groups' | translate }}</h3>
        <table>
          <tr>
            <th>{{ 'appointments.gui.labels.financial_report.Group' | translate }}</th>
            <th>{{ 'appointments.gui.labels.financial_report.Exam Count' | translate }}</th>
            <th>{{ 'appointments.gui.labels.financial_report.Total Reimbursement' | translate }}</th>
            <th>{{ 'appointments.gui.labels.financial_report.Received From Payer' | translate }}</th>
            <th>{{ 'appointments.gui.labels.financial_report.Total Remuneration' | translate }}</th>
            <th>{{ 'appointments.gui.labels.financial_report.Left To Pay Performers' | translate }}</th>
          </tr>
          <tr *ngFor="let group of groups">
            <td>{{ financialService.payerMapping[group.groupLabel] || group.groupLabel }}</td>
            <td>{{ group.examCount }}</td>
            <td>{{ group.totalReimbursement | number:'1.0-2' }}</td>
            <td>{{ group.receivedFromPayer | number:'1.0-2' }}</td>
            <td>{{ group.totalRemuneration | number:'1.0-2' }}</td>
            <td>{{ group.leftToPayPerformers | number:'1.0-2' }}</td>
          </tr>
        </table>
      </ng-container>

      <hr />
      <div class="flex flex-wrap gap-4" style="align-items: center; margin-bottom: 0.5em;">
        <strong>{{ 'appointments.gui.labels.financial_report.Bulk Update' | translate }}:</strong>
        <select class="t-field" [(ngModel)]="bulkTarget">
          <option value="payer">{{ 'appointments.gui.labels.financial_report.Payer Status' | translate }}</option>
          <option value="performer">{{ 'appointments.gui.labels.financial_report.Performer Status' | translate }}</option>
        </select>
        <select class="t-field" [(ngModel)]="bulkStatus">
          <option *ngFor="let status of financialService.statuses" [value]="status">{{ 'appointments.gui.labels.financial_report.status.' + status | translate }}</option>
        </select>
        <button class="blue-btn" [disabled]="!selected.size" (click)="applyBulk()">{{ 'appointments.gui.labels.financial_report.Apply To Selected' | translate }} ({{ selected.size }})</button>
      </div>

      <table>
        <tr>
          <th><input type="checkbox" [checked]="allSelected" (change)="toggleAll($any($event.target).checked)" /></th>
          <th>{{ 'appointments.gui.labels.financial_report.Performer' | translate }}</th>
          <th>{{ 'appointments.gui.labels.Payer' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Exam' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Patient ID' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Patient Name' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Exam Date' | translate }}</th>
          <th>{{ 'appointments.gui.labels.Reimbursement Amount' | translate }}</th>
          <th>{{ 'appointments.gui.labels.Performer Remuneration Percent' | translate }}</th>
          <th>{{ 'appointments.gui.labels.Performer Remuneration Sum' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Payer Status' | translate }}</th>
          <th>{{ 'appointments.gui.labels.financial_report.Performer Status' | translate }}</th>
        </tr>
        <tr *ngFor="let row of rows" [style.color]="row.missingPrice ? 'red' : null">
          <td><input type="checkbox" [(ngModel)]="row.selected" (ngModelChange)="toggleRow(row)" /></td>
          <td>{{ row.doctorName }}</td>
          <td>{{ financialService.payerMapping[row.payer] || row.payer }}</td>
          <td>{{ row.ExamType }}</td>
          <td>{{ row.patientID }}</td>
          <td>{{ row.patientName }}</td>
          <td>{{ row.examDate | date:'dd/MM/yyyy' }}</td>
          <td>{{ row.reimbursementPrice | number:'1.0-2' }}</td>
          <td>{{ row.remunerationPercent }}</td>
          <td>{{ row.remunerationSum | number:'1.0-2' }}</td>
          <td>
            <select class="t-select" [(ngModel)]="row.payerStatus" (ngModelChange)="changeStatus(row, 'payerStatus')">
              <option *ngFor="let status of financialService.statuses" [value]="status">{{ 'appointments.gui.labels.financial_report.status.' + status | translate }}</option>
            </select>
          </td>
          <td>
            <select class="t-select" [(ngModel)]="row.performerStatus" (ngModelChange)="changeStatus(row, 'performerStatus')">
              <option *ngFor="let status of financialService.statuses" [value]="status">{{ 'appointments.gui.labels.financial_report.status.' + status | translate }}</option>
            </select>
          </td>
        </tr>
        <tr *ngIf="!rows.length">
          <td colspan="12">{{ 'appointments.gui.labels.financial_report.No Results' | translate }}</td>
        </tr>
      </table>

      <mat-paginator
        [length]="totalRows"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[25, 50, 100, 200]"
        [dir]="pageDirection"
        (page)="onPage($event)"
      ></mat-paginator>
    </ng-container>
  </div>
</div>
